import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getLang, setLanguage } from '../i18n';
import { getLangFromSelfRegistrationPath } from '../utils/redirectUtils';

/**
 * Keeps the UI language in step with the localized self-registration path in the URL,
 * so landing on /registrer-deg renders a Norwegian UI even when another language is
 * stored in localStorage. Dispatches the same `changeLang` event the language switcher
 * does, which is what the pages already listen for to re-render.
 */
const useSelfRegistrationLanguage = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const pathLang = getLangFromSelfRegistrationPath(pathname);
    if (!pathLang) {
      return;
    }

    // The language of the link the customer followed is theirs even when it happens to match the
    // one already in use, so it is always marked as chosen. Only a real change needs the event.
    const changed = pathLang !== getLang();
    setLanguage(pathLang, true);

    if (changed) {
      document.dispatchEvent(new CustomEvent('changeLang', {
        detail: {
          lang: pathLang
        }
      }));
    }
  }, [pathname]);
};

export default useSelfRegistrationLanguage;
